module.exports = __webpack_public_path__ + "img/achievement.7b464287.png";